import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndrawPreferences = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 739 505",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M725.214 458.915c-5.052 17.527-19.804 29.796-35.192 40.218q-3.222 2.183-6.447 4.266c-.015.006-.03.02-.045.026-.103.067-.207.133-.303.2l-1.328.855.242.109s.237.126-.022.02c-.078-.033-.158-.062-.236-.094-8.939-3.605-18.037-7.476-24.888-14.23-7.106-7.014-11.26-18.015-7.411-27.228a17.592 17.592 0 011.905-3.42c.312-.446.648-.873.998-1.293a18.856 18.856 0 0132.386 5.73c1.13-10.526-7.549-19.343-15.902-25.848-8.356-6.503-17.85-13.584-19.466-24.051-.902-5.824 1.123-11.468 4.812-15.999.114-.137.228-.275.346-.409a27.518 27.518 0 0117.687-9.489c12.813-1.331 25.26 5.451 34.568 14.36 14.982 14.333 24.039 36.35 18.296 56.277z",
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M701.13 435.991a46.78 46.78 0 015.604 12.361 40.62 40.62 0 011.404 11.997 52.044 52.044 0 01-6.816 23.684 74.903 74.903 0 01-11.3 15.1q-3.222 2.183-6.447 4.266c-.015.006-.03.02-.045.026-.103.067-.207.133-.303.2l-1.328.855s.48.235.22.129c-.078-.033-.158-.062-.236-.094a41.405 41.405 0 00-13.249-35.65 41.76 41.76 0 00-17.145-9.227c.312-.447.648-.874.998-1.294a43.296 43.296 0 017.147 2.704 42.424 42.424 0 0119.182 18.494 43.374 43.374 0 014.722 23.801c.367-.333.735-.673 1.092-1.01 6.793-6.333 12.826-13.602 16.91-21.992a48.416 48.416 0 005.07-22.907c-.334-8.653-3.782-16.668-8.774-23.646a101.345 101.345 0 00-19.21-19.799 115.158 115.158 0 00-23.892-14.75.828.828 0 01-.417-1.063.704.704 0 01.346-.409.613.613 0 01.532.023c1.054.485 2.1.977 3.139 1.49a116.465 116.465 0 0124.062 15.873c7.083 6.038 13.751 12.937 18.734 20.838z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M615.72 0h-607A8.728 8.728 0 000 8.72v411.32a8.728 8.728 0 008.72 8.72h607a8.712 8.712 0 006.63-3.06 2.046 2.046 0 00.19-.24 8.167 8.167 0 001.25-2.11 8.507 8.507 0 00.66-3.31V8.72A8.73 8.73 0 00615.72 0zm6.24 420.04a6.175 6.175 0 01-1.03 3.42 6.446 6.446 0 01-2.36 2.12 6.184 6.184 0 01-2.85.69h-607a6.238 6.238 0 01-6.23-6.23V8.72a6.238 6.238 0 016.23-6.23h607a6.24 6.24 0 016.24 6.23z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3f3d56",
			d: "M1.243 34.949H623.2v2.493H1.243z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 22.432,
			cy: 18.696,
			r: 7.478,
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 43.932,
			cy: 18.696,
			r: 7.478,
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 65.433,
			cy: 18.696,
			r: 7.478,
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M402.812 175.36a20.174 20.174 0 1120.174-20.174 20.197 20.197 0 01-20.174 20.175zm0-38.436a18.262 18.262 0 1018.262 18.262 18.283 18.283 0 00-18.262-18.262z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M400.908 162.518a1.993 1.993 0 01-1.2-.399l-.02-.016-4.517-3.455a2.007 2.007 0 012.442-3.186l2.925 2.244 6.913-9.02a2.006 2.006 0 012.813-.37l-.042.06.044-.06a2.009 2.009 0 01.371 2.813l-8.131 10.603a2.007 2.007 0 01-1.597.783z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.537 175.36a20.174 20.174 0 1120.174-20.174 20.197 20.197 0 01-20.174 20.175zm0-38.436a18.262 18.262 0 1018.262 18.262 18.283 18.283 0 00-18.262-18.262z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M467.799 162.167a1.293 1.293 0 01-1.826 0l-4.841-4.841a.576.576 0 00-.814 0l-4.841 4.84a1.291 1.291 0 01-1.827-1.826l4.841-4.84a.576.576 0 000-.814l-4.84-4.842a1.291 1.291 0 011.825-1.826l4.842 4.842a.576.576 0 00.813 0l4.841-4.841a1.291 1.291 0 011.827 1.826l-4.841 4.84a.576.576 0 000 .815l4.84 4.84a1.293 1.293 0 010 1.827z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M402.812 239.41a20.174 20.174 0 1120.174-20.174 20.197 20.197 0 01-20.174 20.174zm0-38.436a18.262 18.262 0 1018.262 18.262 18.283 18.283 0 00-18.262-18.262z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M400.908 226.567a1.993 1.993 0 01-1.2-.398l-.02-.016-4.517-3.455a2.007 2.007 0 012.442-3.186l2.925 2.243 6.913-9.019a2.006 2.006 0 012.813-.371l-.042.06.044-.06a2.009 2.009 0 01.371 2.814l-8.131 10.603a2.007 2.007 0 01-1.597.783z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.537 239.41a20.174 20.174 0 1120.174-20.174 20.197 20.197 0 01-20.174 20.174zm0-38.436a18.262 18.262 0 1018.262 18.262 18.283 18.283 0 00-18.262-18.262z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M467.799 226.216a1.293 1.293 0 01-1.826 0l-4.841-4.84a.576.576 0 00-.814 0l-4.841 4.84a1.291 1.291 0 01-1.827-1.826l4.841-4.841a.576.576 0 000-.814l-4.84-4.841a1.291 1.291 0 011.825-1.826l4.842 4.841a.576.576 0 00.813 0l4.841-4.84a1.291 1.291 0 011.827 1.825l-4.841 4.841a.576.576 0 000 .814l4.84 4.841a1.293 1.293 0 010 1.826zM402.812 303.46a20.174 20.174 0 1120.174-20.174 20.197 20.197 0 01-20.174 20.174zm0-38.437a18.262 18.262 0 1018.262 18.263 18.283 18.283 0 00-18.262-18.263z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 395",
			d: "M400.908 290.617a1.993 1.993 0 01-1.2-.399l-.02-.016-4.517-3.455a2.007 2.007 0 012.442-3.186l2.925 2.244 6.913-9.019a2.006 2.006 0 012.813-.371l-.042.06.044-.06a2.009 2.009 0 01.371 2.813l-8.131 10.604a2.007 2.007 0 01-1.597.782z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M460.537 303.46a20.174 20.174 0 1120.174-20.174 20.197 20.197 0 01-20.174 20.174zm0-38.437a18.262 18.262 0 1018.262 18.263 18.283 18.283 0 00-18.262-18.263z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M467.799 290.266a1.293 1.293 0 01-1.826 0l-4.841-4.841a.576.576 0 00-.814 0l-4.841 4.84a1.291 1.291 0 01-1.827-1.826l4.841-4.84a.576.576 0 000-.814l-4.84-4.841a1.291 1.291 0 011.825-1.826l4.842 4.84a.576.576 0 00.813 0l4.841-4.84a1.291 1.291 0 011.827 1.826l-4.841 4.841a.576.576 0 000 .814l4.84 4.84a1.293 1.293 0 010 1.827z",
			fill: "#e6e6e6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M737.418 504.356h-381a1 1 0 010-2h381a1 1 0 110 2z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M410.659 231.442a10.056 10.056 0 0014.588-4.995l35.715 1.189-9.702-15.834-32.428 1.299a10.11 10.11 0 00-8.173 18.34zM612.033 308.802a10.056 10.056 0 00-2.363-15.238l7.425-34.955-17.288 6.78-4.4 32.154a10.11 10.11 0 0016.626 11.259zM528.369 490.974l-12.26-.001-5.832-47.288 18.094.001-.002 47.288z",
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M531.495 502.858l-39.53-.001v-.5a15.386 15.386 0 0115.386-15.387h.001l24.144.001z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffb8b8",
			d: "M588.369 490.974l-12.26-.001-5.832-47.288 18.094.001-.002 47.288z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M591.495 502.858l-39.53-.001v-.5a15.386 15.386 0 0115.386-15.387h.001l24.144.001zM529.646 466.282l-17.355-.695a4.514 4.514 0 01-4.318-4.633l4.89-160.38.32-.115c30.415-11.003 55.577-10.17 76.925 2.54l.239.143 2.929 156.202a4.5 4.5 0 01-4.5 4.585h-14.633a4.51 4.51 0 01-4.416-3.632l-19.935-101.409a1.5 1.5 0 00-2.961.11l-12.538 103.33a4.526 4.526 0 01-4.47 3.957 5.51 5.51 0 01-.177-.003z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 546.529,
			cy: 135.366,
			r: 24.561,
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M431.063 225.638a4.506 4.506 0 01-.002-2.686l2.545-8.153a4.515 4.515 0 014.097-3.155l32.223-1.424 52.278-26.799a14.497 14.497 0 118.785 27.63l-32.038 18.583a46.374 46.374 0 01-32.195 5.397l-32.264-6.322a4.505 4.505 0 01-3-2.112 4.455 4.455 0 01-.43-.96zM610.984 286.171a4.506 4.506 0 01-2.683.116l-8.254-2.195a4.515 4.515 0 01-3.327-3.959L593.924 248l-29.002-51.089a14.497 14.497 0 1127.23-9.954l19.932 31.217a46.373 46.373 0 016.763 31.936l-4.94 32.504a4.505 4.505 0 01-1.983 3.088 4.455 4.455 0 01-.94.47z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M519.665 178.983a41.822 41.822 0 0133.537-13.56q.616.039 1.227.087a41.734 41.734 0 0130.16 16.646 42.362 42.362 0 017.525 34.145 132.361 132.361 0 003.497 67.876l6.588 20.459a4.499 4.499 0 01-4.042 5.872l-33.685 1.81-8.62-14.889v15.353l-40.94 2.201a4.067 4.067 0 01-.244.007 4.5 4.5 0 01-4.484-4.861l4.628-57.382-5.805-38.973a42.09 42.09 0 0110.658-34.79z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M563.6 158.813c-2.275 1.309-11.263 2.176-11.903-.368l-.014-.056c-.446-1.864-.076-3.81.052-5.723s-.06-4.013-1.362-5.42c-2.428-2.62-6.747-1.231-10.258-1.894a8.664 8.664 0 01-6.74-9.253c.05-.397.128-.795.216-1.193a6.673 6.673 0 00-6.927-8.081c-3.548.203-7.378 1.278-10.313-1.35-2.27-2.033-2.824-7.323-1.827-10.202 1.677-4.838 12.414-7.37 17.102-8.763a40.62 40.62 0 0134.43 5.65c2.962 2.086 5.727 4.709 6.99 8.105s.652 7.68-2.194 9.922a18.332 18.332 0 014.247 17.806c-1.406 4.53-8.115 8.872-11.5 10.82z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.622 160.073H67.36a7.648 7.648 0 010-15.295h157.26a7.648 7.648 0 010 15.295z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M321.713 166.595h-270a1 1 0 010-2h270a1 1 0 010 2z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.622 224.123H67.36a7.648 7.648 0 010-15.296h157.26a7.648 7.648 0 010 15.296z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M321.713 230.645h-270a1 1 0 010-2h270a1 1 0 010 2z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M224.622 288.172H67.36a7.648 7.648 0 010-15.295h157.26a7.648 7.648 0 010 15.295z",
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M321.713 294.694h-270a1 1 0 110-2h270a1 1 0 010 2z",
			fill: "#3f3d56"
		})
	]
});
export default SvgUndrawPreferences;
